import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Notifications from "../components/Notifications";
import { hasRole } from "../utils/api";
import "../App.css";
import { useTranslation } from "react-i18next";

export default function Home() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        // Redirect owners to their dashboard
        if (hasRole("owner")) {
            navigate("/owner");
        }
    }, [navigate]);

    const currentYear = new Date().getFullYear();

    return (
        <div className="home-page">
            <section className="home-hero">
                <div className="features-grid hero-features">
                    <div className="feature-card glass" onClick={() => navigate("/apartments")}>
                        <div className="feature-icon">🏠</div>
                        <h3>{t("home.addApartmentTitle")}</h3>
                        <p>{t("home.addApartmentDescription")}</p>
                        <div className="btn-quick-action">
                            <span className="plus-icon">+</span>
                            <span>{t("home.addApartmentTitle")}</span>
                        </div>
                    </div>
                    <div className="feature-card glass" onClick={() => navigate("/invoices")}>
                        <div className="feature-icon">📄</div>
                        <h3>{t("home.addInvoiceTitle")}</h3>
                        <p>{t("home.addInvoiceDescription")}</p>
                        <div className="btn-quick-action">
                            <span className="plus-icon">+</span>
                            <span>{t("home.addInvoiceTitle")}</span>
                        </div>
                    </div>
                    <div className="feature-card glass" onClick={() => navigate("/financial")}>
                        <div className="feature-icon">💰</div>
                        <h3>{t("home.addFinancialTitle")}</h3>
                        <p>{t("home.addFinancialDescription")}</p>
                        <div className="btn-quick-action">
                            <span className="plus-icon">+</span>
                            <span>{t("home.addFinancialTitle")}</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="home-notifications">
                <Notifications />
            </section>

            <footer className="home-footer">
                <p>{t("home.footer", { year: currentYear })}</p>
            </footer>
        </div>
    );
}
